// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoVimeo_root__JQ5xi","errorContainer":"VideoVimeo_errorContainer__38fNd"};